import React, { useState, useEffect } from 'react'
// import { useParams } from 'react-router-dom'
// import { useSelector } from 'react-redux'
import { Panel, Row, Table, ButtonGroup, Message, IconButton, Icon } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import {
  callGetDownloadService,
  callInfomaDownloadService,
  callGetDownloadFileMs,
} from './AttachFilesViewDownload'
import { getproposalProjectSubmitPdf } from '../../redux/actions/submitProposal'
import notification from '../../utils/notification'
import { includes } from 'lodash-es'

export default function AttachFilesDocWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { schema, infoma, shaded, header, canReload, reloadId } = props
  const [isError, setIsError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)

  const user_code = localStorage.getItem('thp_user_code')

  const onDownloadOrPreview = async (fileObj, type) => {
    let result
    // console.log('fileObj = ', fileObj)
    if (infoma) {
      if (type == 'download') {
        onDownloadOnTheFile(fileObj)
      } else {
        onPreviewOnTheFiles(fileObj)
      }
    } else {
      result = await callGetDownloadService(projectId, fileObj, type)
    }

    // console.log('error', error)
    result ? setIsError(type == 'download' ? 'ดาวน์โหลด' : 'แสดง') : setIsError()
  }

  const onDownloadOnTheFile = async (fileObj) => {
    // console.log('fileObj => ', fileObj)

    setIsLoadingPDF(true)
    startLoading()
    try {
      // var file = await doDownload(fileObj.documentFilePath)
      // const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const url = fileObj.path
      const link = document.createElement('a')

      link.href = url
      link.target = '_blank'
      link.setAttribute('download', `${fileObj.fileName}.${fileObj.type}`)

      document.body.appendChild(link)
      link.click()
      // doneLoading()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ดาวน์โหลดไม่สำเร็จ',
      })
    }

    doneLoading()
    setIsLoadingPDF(false)
  }

  const onDownloadFilems = async (fileObj) => {
    // console.log('fileObj ms >> ', fileObj)
    const error = await callGetDownloadFileMs(fileObj)
    error ? setIsError('ดาวน์โหลด') : setIsError()
  }

  const onPreviewOnTheFiles = async (fileObj) => {
    startLoading()
    setIsLoadingPDF(true)
    try {
      //var file = await downloadFileByPath(fileObj.documentFilePath)
      const url = fileObj.path
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.setAttribute('value', `${fileObj.fileName}.${fileObj.type}`)
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'แสดงไม่สำเร็จ',
      })
    }

    doneLoading()
    setIsLoadingPDF(false)
  }

  const onReload = async (rowData) => {
    startLoading()
    setIsLoadingPDF(true)
    try {
      const response = await getproposalProjectSubmitPdf(projectId)

      if (response) {
        setIsPdfError(true)
        setTimeout(() => setIsPdfError(false), 5000)
      } else {
        response ? setIsError('แสดง') : setIsError()
      }
    } catch (error) {
      error ? setIsError('แสดง') : setIsError()
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={schema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: 10 }}
      {...props}
    >
      <Row style={{ marginBottom: 10 }}>
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={`เกิดข้อผิดพลาดในการ${isError} กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
            />
          </Row>
        )}

        {isLoadingPDF && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="warning"
              description={`กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ...`}
            />
          </Row>
        )}

        {isPdfError && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="success"
              description={`ระบบกำลังสร้าง PDF ข้อเสนอโครงการ สำเร็จ`}
            />
          </Row>
        )}

        <Table
          height={400}
          autoHeight={schema?.fileLists?.values.length <= 5}
          wordWrap
          bordered
          data={schema?.fileLists?.values || []}
        >
          <Column width={70} align="center" fixed="left">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={350} width={350} flexGrow={1}>
            <HeaderCell>ชื่อเอกสาร</HeaderCell>
            <Cell dataKey="fileName" />
          </Column>

          <Column width={canReload ? 380 : 260} fixed="right">
            <HeaderCell></HeaderCell>
            <Cell style={{ marginRight: 20, textAlign: 'center' }}>
              {(rowData) => {
                if (rowData.type === 'docx') {
                  // console.log('row data ', rowData)
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        disabled={!rowData.isExists}
                        onClick={(e) => onDownloadFilems(rowData)}
                      >
                        ดาวน์โหลด
                      </IconButton>
                    </ButtonGroup>
                  )
                }
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      disabled={!rowData.isExists}
                      onClick={(e) => onDownloadOrPreview(rowData, 'preview')}
                    >
                      แสดง
                    </IconButton>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      disabled={!rowData.isExists}
                      onClick={(e) => onDownloadOrPreview(rowData, 'download')}
                    >
                      ดาวน์โหลด
                    </IconButton>
                    {canReload &&
                      user_code == 'THP-Coordinator' &&
                      reloadId?.includes(rowData.id) && (
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="refresh" className="bt-gost-icon-none-radius" />}
                          disabled={isLoadingPDF}
                          onClick={(e) => onReload(rowData)}
                        >
                          {'reload'}
                        </IconButton>
                      )}
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Row>
    </Panel>
  )
}
